<div class="diagram mt-5">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 599 600">
    <g id="Overall_Mechanics" data-name="Overall Mechanics" transform="translate(-403 -103)">
      <circle
        id="Ellipse_32"
        data-name="Ellipse 32"
        cx="3.302"
        cy="3.302"
        r="3.302"
        transform="translate(712.647 126.715)"
        fill="#ffe6b7"
        stroke="#030504"
        stroke-miterlimit="10"
        stroke-width="1"
      />
      <circle
        id="Ellipse_33"
        data-name="Ellipse 33"
        cx="3.302"
        cy="3.302"
        r="3.302"
        transform="translate(740.717 126.715)"
        fill="#ffe6b7"
        stroke="#030504"
        stroke-miterlimit="10"
        stroke-width="1"
      />
      <line
        id="Line_35"
        data-name="Line 35"
        x1="10.733"
        y2="39.215"
        transform="translate(705.217 130.017)"
        fill="#94cdae"
        stroke="#030504"
        stroke-miterlimit="10"
        stroke-width="1"
      />
      <line
        id="Line_36"
        data-name="Line 36"
        x1="31.372"
        y2="43.756"
        transform="translate(712.647 130.017)"
        fill="#94cdae"
        stroke="#030504"
        stroke-miterlimit="10"
        stroke-width="1"
      />
      <g id="Group_272" data-name="Group 272" transform="translate(696.651 236.437)">
        <path
          id="Path_227"
          data-name="Path 227"
          d="M312.884,352.88l1.775.888,4.279,2.14v-9.494l-6.054,1.789Z"
          transform="translate(-266.961 -296.109)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_wheel'] || ''"
        [attr.data-name]="'mechanics.lft_rr_wheel' | translate"
      >
        <path
          class="parts"
          id="LFT_RR_Wheel-2"
          data-name="LFT RR Wheel"
          d="M210.907,451.882V434.508l-1.452-3.853s1.651-17.337-4.953-17.337H182s-4.128-1.238-5.572,9.494-11.595,88.13,12.469,82.145l.74-8.461,3.3-3.548s-1.238-31.126,11.559-30.715V446.548h3.3Z"
          transform="translate(392.356 -41.817)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="104"
          height="18"
          rx="9"
          transform="translate(425 430)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LFT_RR_Wheel-3"
          data-name="LFT RR Wheel"
          transform="translate(442 442)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.lft_rr_wheel' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow">
          <path
            id="Path_264"
            data-name="Path 264"
            d="M6207.836,979.656l-40.807,14.277H6157"
            transform="translate(-5628.604 -553.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_308"
            data-name="Path 308"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(576 423)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 430)"
          fill="#f9b22a"
        />
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(513 441)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['steering_system'] || ''"
        [attr.data-name]="'mechanics.steering_system' | translate"
      >
        <path
          class="parts"
          id="Steering_System-2"
          data-name="Steering System"
          d="M8317.326,2004.682l9.439,36.482h4.348l-9.574-37.16Z"
          transform="translate(-7658 -1803)"
          fill="none"
          stroke="#707070"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="108"
          height="18"
          rx="9"
          transform="translate(421 167)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Steering_System-3"
          data-name="Steering System"
          transform="translate(431 179)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.steering_system' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 167)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(513 178)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Steering_System-4"
            data-name="Steering System"
            d="M6294.656,979.656l-110.5,45.325H6157"
            transform="matrix(0.839, 0.545, -0.545, 0.839, -4079.364, -4030.341)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_245"
            data-name="Ellipse 245"
            cx="3"
            cy="3"
            r="3"
            transform="translate(663 216)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['climate_control'] || ''"
        [attr.data-name]="'mechanics.climate_control' | translate"
      >
        <path
          class="parts"
          id="Climate_Control-2"
          data-name="Climate Control"
          d="M218.448,258.546h-9.377a10.179,10.179,0,0,0-18.674,0h-9.376a10.183,10.183,0,0,0,0,20.365H190.4a10.179,10.179,0,0,0,18.674,0h9.377a10.183,10.183,0,0,0,0-20.365Z"
          transform="translate(391.758 -84.773)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(422 135)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Climate_Control-3"
          data-name="Climate Control"
          transform="translate(434 147)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.climate_control' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_254"
            data-name="Path 254"
            d="M6225.391,1019.535l-54.9-39.879H6157"
            transform="translate(-5627.604 -835.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_316"
            data-name="Path 316"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(595 181)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 135)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(513 146)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_wheel'] || ''"
        [attr.data-name]="'mechanics.lft_frt_wheel' | translate"
      >
        <path
          class="parts"
          id="LFT_FRT_Wheel-2"
          data-name="LFT FRT Wheel"
          d="M226.293,359l-1.252,23.33s-.481,4.54-6.88,4.54h-9.287s-6.605-.31-6.605-7.275V336.713s-.682-9.879,9.287-9.879h9.185l5.4,5.545v7.843s-3.957,1.444-.345,5.159c0,0-4.112,3.406-1.444,5.573l3.715,2.477v4.679Z"
          transform="translate(400.148 -64.901)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(423 263)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LFT_FRT_Wheel-3"
          data-name="LFT FRT Wheel"
          transform="translate(437 275)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.lft_frt_wheel' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_259"
            data-name="Path 259"
            d="M6238.295,996.362l-65.258-16.706H6157"
            transform="translate(-5628.604 -706.261)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_314"
            data-name="Path 314"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(607 287)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 263)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(513 274)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['battery'] || ''"
        [attr.data-name]="'mechanics.battery' | translate"
      >
        <path
          class="parts"
          id="Battery-2"
          data-name="Battery"
          d="M209.825,385.981l3.317,25.318,31.083,15.273,12.384-12.384,2.477-28.208-6.742-4.128-1.789,1.514L226.047,379.1Z"
          transform="translate(402.169 -50.943)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <g id="Group_106" data-name="Group 106" transform="translate(449.95 327)">
          <rect
            id="Rectangle_38-5"
            data-name="Rectangle 38"
            width="79"
            height="18"
            rx="9"
            transform="translate(0.05)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <text
          id="Battery-3"
          data-name="Battery"
          transform="translate(472 339)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.battery' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_261"
            data-name="Path 261"
            d="M6264.315,996.362l-86.145-16.706H6157"
            transform="translate(-5627.604 -643.261)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_311"
            data-name="Path 311"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(634 350)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 327)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(513 338)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_shocks'] || ''"
        [attr.data-name]="'mechanics.rr_shocks' | translate"
      >
        <g class="parts" id="RR_Shocks-2" data-name="RR Shocks">
          <path
            id="Path_251"
            data-name="Path 251"
            d="M325.734,437.845l-.224,2.257s-5.056.261-3.506,4.148,12.107,3.413,12.107,3.413l.883-8.9-1.789-2.182.459-1.13,2.464.245.435-4.381-1.917-.19.176-1.78,1.917.19.489-4.929-2.191-.218.177-1.78,2.191.218.589-5.941-1.643-.163.12-1.2,2.865.284s1.546-10.425-6.523-9.609c-7.386-.9-6.6,6.812-6.6,6.812l-.367,3.7.987,1.2-.272,2.738-2.629-.261-.258,2.6,2.467,1.9-.136,1.37-4.245-.421-.2,2.053,3.877,4.119-.19,1.917-3.424-.34-.3,3.012Z"
            transform="translate(431.997 -43.728)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_252"
            data-name="Path 252"
            d="M215.907,437.989l.153,2.263s5.045.419,3.374,4.256-12.207,3.033-12.207,3.033l-.6-8.923,1.856-2.126-.423-1.144-2.471.169-.3-4.393,1.922-.13-.12-1.785-1.922.13-.336-4.943,2.2-.148-.122-1.785-2.2.15-.4-5.956,1.647-.113-.081-1.206-2.872.2s-1.22-10.47,6.819-9.4c7.411-.67,6.386,7.014,6.386,7.014l.251,3.706-1.024,1.173.186,2.746,2.637-.179.177,2.608-2.525,1.826L216,426.4l4.256-.289.139,2.06-4.005,4,.131,1.921,3.432-.232.205,3.021Z"
            transform="translate(400.329 -43.745)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </g>
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="88"
          height="18"
          rx="9"
          transform="translate(441 366)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Shocks-3"
          data-name="RR Shocks"
          transform="translate(456 378)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.rr_shocks' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_262"
            data-name="Path 262"
            d="M6237.295,979.656l-64.455,9.4H6157"
            transform="translate(-5627.604 -613.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_310"
            data-name="Path 310"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(607 363)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 366)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(513 377)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['exhaust'] || ''"
        [attr.data-name]="'mechanics.exhaust' | translate"
      >
        <path
          class="parts"
          id="Exhaust-2"
          data-name="Exhaust"
          d="M397.93,487.289l-3.3-3.548s1.239-31.128-11.558-30.715c-9.1.294-11.351,3.1-11.351,3.1l-25.8,15.273s-4.678-1.1-5.229.275-.275,3.853-2.2,4.678-21.26-11.558-21.26-11.558h-6.191L305.3,468.37l-13.182-.551-13.182.551-5.736-3.578h-6.192s-19.333,12.384-21.259,11.558-1.651-3.3-2.2-4.678-5.229-.275-5.229-.275l-25.8-15.273s-2.252-2.8-11.351-3.1c-12.8-.413-11.558,30.715-11.558,30.715l-3.3,3.548c-4.746,29.308,14.861,27.13,14.861,27.13s.55-10.274,8.255-10.274,6.88,8.806,6.88,8.806,2.752,3.3,10.458,0,8.531-23.116,7.98-29.17,5.5-3.853,9.632-.826S269.417,471.4,269.417,471.4l4.128-.275,5.391,3.027H305.3l5.391-3.027,4.128.275s20.915,14.585,25.043,11.558,10.182-5.229,9.631.826.276,25.868,7.981,29.17,10.457,0,10.457,0-.825-8.806,6.88-8.806,8.256,10.274,8.256,10.274S402.676,516.6,397.93,487.289Z"
          transform="translate(403.175 -11.515)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="81"
          height="18"
          rx="9"
          transform="translate(448 462)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Exhaust-3"
          data-name="Exhaust"
          transform="translate(468 474)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.exhaust' | translate }}</tspan>
        </text>
        <g class="parts" id="Exhaust-4" data-name="Exhaust">
          <path
            id="Path_265"
            data-name="Path 265"
            d="M6231.017,979.656,6171.6,993.933H6157"
            transform="translate(-5627.604 -522.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_307"
            data-name="Path 307"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(601 454)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 462)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(513 473)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['fuel_tank'] || ''"
        [attr.data-name]="'mechanics.fuel_tank' | translate"
      >
        <path
          class="parts"
          id="Fuel_Tank-2"
          data-name="Fuel Tank"
          d="M238.278,522.684l15.961-36.876h46.508s1.651,2.476,4.4,0,6.605-6.605,15.686-3.027c6.605,4.318-6.329,4.265-6.329,4.265s-6.743-.825-6.743,7.018V524.61l-5.711,5.711h-51.8Z"
          transform="translate(409.767 -23.629)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="84"
          height="18"
          rx="9"
          transform="translate(445 494)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Fuel_Tank-3"
          data-name="Fuel Tank"
          transform="translate(461 506)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.fuel_tank' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_306"
            data-name="Path 306"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(670 498)"
            fill="#696969"
          />
          <path
            id="Path_266"
            data-name="Path 266"
            d="M6301.717,979.656l-116.169,1.5H6157"
            transform="translate(-5628.604 -478.875)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 494)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(513 505)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lr_win_mechanics'] || ''"
        [attr.data-name]="'mechanics.lr_win_machanics' | translate"
      >
        <path
          class="parts"
          id="LR_Win_Mechanics-2"
          data-name="LR Win Mechanics"
          d="M233.441,597.146V573.273h32.547V594.41Z"
          transform="translate(408.476 0.911)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="122"
          height="18"
          rx="9"
          transform="translate(407 536)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LR_Win_Mechanics-3"
          data-name="LR Win Mechanics"
          transform="translate(422 548)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.lr_win_machanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_268"
            data-name="Path 268"
            d="M6280.7,1017.5l-99.3-37.84H6157"
            transform="translate(-5627.604 -434.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_304"
            data-name="Path 304"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(649 580)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 536)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(513 547)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lf_win_mechanics'] || ''"
        [attr.data-name]="'mechanics.lf_win_mechanics' | translate"
      >
        <path
          class="parts"
          id="LF_Win_Mechanics-2"
          data-name="LF Win Mechanics"
          d="M187.78,587.722v4.954l8.3,11.814,37.533-5.979,2.468-25.236S205.943,572.448,187.78,587.722Z"
          transform="translate(396.282 0.909)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="121"
          height="18"
          rx="9"
          transform="translate(408 568)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LF_Win_Mechanics-3"
          data-name="LF Win Mechanics"
          transform="translate(422 580)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.lf_win_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_269"
            data-name="Path 269"
            d="M6233.221,991.1l-61.184-11.448H6157"
            transform="translate(-5623.531 -402.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_303"
            data-name="Path 303"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(605 586)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 568)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(513 579)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lf_door_mechanics'] || ''"
        [attr.data-name]="'mechanics.lf_door_mechanics' | translate"
      >
        <path
          class="parts"
          id="LF_Door_Mechanics-2"
          data-name="LF Door Mechanics"
          d="M181.881,638.836l-5.5-28.07,2.752-8.256,62.194-9.907,3.853,46.233Z"
          transform="translate(393.237 6.073)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="126"
          height="18"
          rx="9"
          transform="translate(403 600)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LF_Door_Mechanics-3"
          data-name="LF Door Mechanics"
          transform="translate(418 612)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.lf_door_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_270"
            data-name="Path 270"
            d="M6225.935,993.1,6170.6,979.656H6157"
            transform="translate(-5627.604 -371.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_302"
            data-name="Path 302"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(595 618)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 600)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(513 611)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lr_door_mechanics'] || ''"
        [attr.data-name]="'mechanics.lr_door_mechanics' | translate"
      >
        <path
          class="parts"
          id="LR_Door_Mechanics-2"
          data-name="LR Door Mechanics"
          d="M231.488,639.909l33.719-1.789s24.21-41.692,22.972-49.535l-60.543,5.091Z"
          transform="translate(406.925 5)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="125"
          height="18"
          rx="9"
          transform="translate(404 632)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="LR_Door_Mechanics-3"
          data-name="LR Door Mechanics"
          transform="translate(417 644)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.lr_door_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_271"
            data-name="Path 271"
            d="M6293.824,979.656l-109.833,11.23H6157"
            transform="translate(-5627.604 -352.58)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_301"
            data-name="Path 301"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(663 624)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 632)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(513 643)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['others'] || ''"
        [attr.data-name]="'mechanics.others' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="70"
          height="19"
          rx="9.5"
          transform="translate(866 684)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Others-2"
          data-name="Others"
          transform="translate(888 697)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.others' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 685)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(868 696)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rf_door_mechanics'] || ''"
        [attr.data-name]="'mechanics.rf_door_mechanics' | translate"
      >
        <path
          class="parts"
          id="RF_Door_Mechanics-2"
          data-name="RF Door Mechanics"
          d="M386.707,638.836l5.5-28.07-2.752-8.256L327.265,592.6l-3.853,46.233Z"
          transform="translate(432.502 6.073)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="123"
          height="19"
          rx="9.5"
          transform="translate(866 620)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RF_Door_Mechanics-3"
          data-name="RF Door Mechanics"
          transform="translate(888 633)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.rf_door_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_285"
            data-name="Path 285"
            d="M6157,980.914l64.728-1.257h15.907"
            transform="translate(-5371.535 -349.96)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_299"
            data-name="Path 299"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(785 628)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 621)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(868 632)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rf_win_mechanics'] || ''"
        [attr.data-name]="'mechanics.rf_win_mechanics' | translate"
      >
        <path
          class="parts"
          id="RF_Win_Mechanics-2"
          data-name="RF Win Mechanics"
          d="M376.487,587.722v4.954l-8.3,11.814-37.533-5.979-2.468-25.236S358.324,572.448,376.487,587.722Z"
          transform="translate(433.778 0.909)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="122"
          height="19"
          rx="9.5"
          transform="translate(866 587)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RF_Win_Mechanics-3"
          data-name="RF Win Mechanics"
          transform="translate(888 600)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.rf_win_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_284"
            data-name="Path 284"
            d="M6157,979.656l62.594,7h15.382"
            transform="translate(-5368.876 -389.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_298"
            data-name="Path 298"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(785 587)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 587)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(868 598)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_win_mechanics'] || ''"
        [attr.data-name]="'mechanics.rr_win_machanics' | translate"
      >
        <path
          class="parts"
          id="RR_Win_Mechanics-2"
          data-name="RR Win Mechanics"
          d="M327.506,597.146V573.273H294.959V594.41Z"
          transform="translate(424.904 0.911)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="121"
          height="19"
          rx="9.5"
          transform="translate(866 554)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Win_Mechanics-3"
          data-name="RR Win Mechanics"
          transform="translate(888 567)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.rr_win_machanics' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 555)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(868 566)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_283"
            data-name="Path 283"
            d="M6157,995.5l110.192-15.84h27.079"
            transform="translate(-5428.172 -412.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_246"
            data-name="Ellipse 246"
            cx="3"
            cy="3"
            r="3"
            transform="translate(725 580)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['seat_mechanics'] || ''"
        [attr.data-name]="'mechanics.seat_mechanics' | translate"
      >
        <path
          class="parts"
          id="Seat_Mechanics-2"
          data-name="Seat Mechanics"
          d="M333.876,529.641H316.557v-6.295a1.16,1.16,0,0,0-1.161-1.159h-18.18a1.16,1.16,0,0,0-1.161,1.159v6.295H282.061a3.427,3.427,0,0,0-3.427,3.427V556.76a3.427,3.427,0,0,0,3.427,3.427h51.815a3.427,3.427,0,0,0,3.427-3.427V533.068A3.427,3.427,0,0,0,333.876,529.641Z"
          transform="translate(1032.482 1069.642) rotate(180)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="107"
          height="19"
          rx="9.5"
          transform="translate(866 495)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Seat_Mechanics-3"
          data-name="Seat Mechanics"
          transform="translate(888 508)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.seat_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_282"
            data-name="Path 282"
            d="M6157,1008.179l113.187-28.523H6298"
            transform="translate(-5432 -475.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_296"
            data-name="Path 296"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(723 530)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 495)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(868 506)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['roof_mechanics'] || ''"
        [attr.data-name]="'mechanics.roof_mechanics' | translate"
      >
        <ellipse
          class="parts"
          id="Roof_Mechanics-2"
          data-name="Roof Mechanics"
          cx="17.087"
          cy="11.273"
          rx="17.087"
          ry="11.273"
          transform="translate(680.958 551.909)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="110"
          height="19"
          rx="9.5"
          transform="translate(866 524)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Roof_Mechanics-3"
          data-name="Roof Mechanics"
          transform="translate(888 537)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.roof_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_334"
            data-name="Path 334"
            d="M6157,1009l139.813-29.34h34.358"
            transform="translate(-5456.172 -446.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_297"
            data-name="Path 297"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(697 561)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 524)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(868 535)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['emissions'] || ''"
        [attr.data-name]="'mechanics.emissions' | translate"
      >
        <g class="parts" id="Emissions-2" data-name="Emissions">
          <rect
            id="Rectangle_71"
            data-name="Rectangle 71"
            width="13.652"
            height="27.599"
            rx="5.188"
            transform="translate(599.211 472.224) rotate(10.302)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <rect
            id="Rectangle_72"
            data-name="Rectangle 72"
            width="13.652"
            height="27.599"
            rx="5.188"
            transform="translate(781.029 499.039) rotate(169.698)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </g>
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="88"
          height="19"
          rx="9.5"
          transform="translate(866 462)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Emissions-3"
          data-name="Emissions"
          transform="translate(888 475)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.emissions' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_281"
            data-name="Path 281"
            d="M6157,1001.8l75.686-22.146h18.6"
            transform="translate(-5385.283 -508.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_295"
            data-name="Path 295"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(769 491)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 462)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(868 473)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['braking_system'] || ''"
        [attr.data-name]="'mechanics.braking_system' | translate"
      >
        <path
          class="parts"
          id="_Braking_System-2"
          data-name=" Braking System"
          d="M374.511,446.586s-10.32,23.116,8.668,29.308,27.107-25.455,19.952-29.859l-.413-6.742s-2.614-5.366-8.118-2.889c0,0-5.366-6.672-10.457-.654C384.143,435.75,371.346,435.578,374.511,446.586Z"
          transform="translate(445.4 -36.486)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="106"
          height="19"
          rx="9.5"
          transform="translate(866 429)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="_Braking_System-3"
          data-name=" Braking System"
          transform="translate(888 442)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0" xml:space="preserve">
            {{ 'mechanics.braking_system' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_280"
            data-name="Path 280"
            d="M6157,979.656l27.3,12.5H6191"
            transform="translate(-5325.005 -553.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_294"
            data-name="Path 294"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(830 423)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 429)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(868 440)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_wheel'] || ''"
        [attr.data-name]="'mechanics.rft_rr_wheel' | translate"
      >
        <path
          class="parts"
          id="RFT_RR_Wheel-2"
          data-name="RFT RR Wheel"
          d="M336.224,452.746V434.892l1.466-3.958s-1.667-17.816,5-17.816h22.706s4.167-1.273,5.624,9.756,11.7,90.562-12.584,84.413l-.748-8.7-3.332-3.645s1.249-31.987-11.666-31.562V447.264h-3.332Z"
          transform="translate(435.924 -41.871)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="113"
          height="19"
          rx="9.5"
          transform="translate(866 353)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RFT_RR_Wheel-3"
          data-name="RFT RR Wheel"
          transform="translate(888 366)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.rft_rr_wheel' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_279"
            data-name="Path 279"
            d="M6157,994.808l63.319-15.152h15.559"
            transform="translate(-5369.878 -617.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_293"
            data-name="Path 293"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(785 374)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 354)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(868 365)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['propeller_shaft'] || ''"
        [attr.data-name]="'mechanics.propeller_shaft' | translate"
      >
        <path
          class="parts"
          id="Propeller_Shaft-2"
          data-name="Propeller Shaft"
          d="M8317.326,2005.517l9.439,81.446h4.348L8321.539,2004Z"
          transform="translate(-7327.598 -2692.001) rotate(7)"
          fill="none"
          stroke="#707070"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="107"
          height="19"
          rx="9.5"
          transform="translate(866 386)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Propeller_Shaft-3"
          data-name="Propeller Shaft"
          transform="translate(888 399)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.propeller_shaft' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_332"
            data-name="Path 332"
            d="M6157,979.656l146.011,10.759h35.881"
            transform="translate(-5472.892 -595.702)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_333"
            data-name="Path 333"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(682 381)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 387)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(868 398)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['clutch'] || ''"
        [attr.data-name]="'mechanics.clutch' | translate"
      >
        <path
          class="parts"
          id="Clutch-2"
          data-name="Clutch"
          d="M320.7,377.973c-5.844,0-11.032,3.465-14.365,8.831a12.344,12.344,0,0,0-8.6-3.686c-7.794,0-14.111,7.923-14.111,17.7s6.318,17.7,14.111,17.7a12.344,12.344,0,0,0,8.6-3.686c3.332,5.366,8.521,8.831,14.365,8.831,10.059,0,18.215-10.226,18.215-22.841S330.757,377.973,320.7,377.973Z"
          transform="translate(421.877 -51.244)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="68"
          height="19"
          rx="9.5"
          transform="translate(866 320)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Clutch-3"
          data-name="Clutch"
          transform="translate(888 333)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.clutch' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_278"
            data-name="Path 278"
            d="M6157,1003.156l113.186-23.5H6298"
            transform="translate(-5432 -650.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_292"
            data-name="Path 292"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(722 350)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 320)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(868 331)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['passenger_door_(bus)'] || ''"
        [attr.data-name]="'mechanics.passenger_door_bus' | translate"
      >
        <g
          class="parts"
          id="Passenger_Door_Bus_2"
          data-name="Passenger Door (Bus)"
          transform="translate(791 273)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-width="1"
        >
          <rect width="16" height="47" rx="5" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="46" rx="4.5" fill="none" />
        </g>
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="136"
          height="19"
          rx="9.5"
          transform="translate(866 287)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Passenger_Door_Bus_3"
          data-name="Passenger Door (Bus)"
          transform="translate(888 300)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.passenger_door_bus' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_277"
            data-name="Path 277"
            d="M6157,979.656h72.14"
            transform="translate(-5358.14 -683.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_291"
            data-name="Path 291"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(796 294)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 288)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(868 299)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_wheel'] || ''"
        [attr.data-name]="'mechanics.rht_frt_wheel' | translate"
      >
        <path
          class="parts"
          id="RHT_FRT_Wheel-2"
          data-name="RHT FRT Wheel"
          d="M314.659,359l1.252,23.33s.481,4.54,6.88,4.54h9.287s6.605-.31,6.605-7.275V336.713s.682-9.879-9.287-9.879H320.21l-5.4,5.545v7.843s3.956,1.444.345,5.159c0,0,4.112,3.406,1.444,5.573l-3.715,2.477v4.679Z"
          transform="translate(429.69 -64.901)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="113"
          height="19"
          rx="9.5"
          transform="translate(866 254)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RHT_FRT_Wheel-3"
          data-name="RHT FRT Wheel"
          transform="translate(888 267)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.rht_frt_wheel' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_276"
            data-name="Path 276"
            d="M6157,986.116l84.288-6.46H6262"
            transform="translate(-5396 -716.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_290"
            data-name="Path 290"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(758 267)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 255)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(868 266)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['engine'] || ''"
        [attr.data-name]="'mechanics.engine' | translate"
      >
        <path
          class="parts"
          id="Engine-2"
          data-name="Engine"
          d="M309.007,314.885l2.58-6.192s-5.469-.413-6.914,3.922c0,0,2.684-9.494-9.7-9.494h-38.8c-12.384,0-9.7,9.494-9.7,9.494-1.446-4.335-6.914-3.922-6.914-3.922l2.58,6.192-5.159,4.335V335.73l2.682,5.574v5.366l13.416,8.118,11.108-1.547c-1.266.176-.585-3.425-.445-4.037,2.091-9.09,19.668-10.16,23.088-1.533.261.659,1.846,5.808.132,5.569l11.112,1.548,13.415-8.118V341.3l2.684-5.574V319.219Z"
          transform="translate(409.419 -71.234)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="72"
          height="19"
          rx="9.5"
          transform="translate(866 221)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Engine-3"
          data-name="Engine"
          transform="translate(888 234)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.engine' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_275"
            data-name="Path 275"
            d="M6157,998.035l136.512-18.379h33.546"
            transform="translate(-5461.058 -749.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_289"
            data-name="Path 289"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(693 246)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 221)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(868 232)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cooling_system'] || ''"
        [attr.data-name]="'mechanics.cooling_system' | translate"
      >
        <path
          class="parts"
          id="Cooling_System-2"
          data-name="Cooling System"
          d="M282.761,294.406s-9.7-30.272-6.295-36.567a6.284,6.284,0,0,0-.3-1.23,7.072,7.072,0,0,1,.39-3.519c2.122-5.578,10.429-8.469,14.852-3.814.365.385,3.2,3.394,2.5,3.919,0,0,7.843-5.883,9.7-1.239h5.573l1.238,3.372c-.336.916-.726,1.827-1.011,2.76-.464,1.513.789,1.565,1.493,2.627.919,1.387.927,3.489.895,5.071l6.88,19.677Z"
          transform="translate(419.772 -86.233)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="105"
          height="19"
          rx="9.5"
          transform="translate(866 188)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Cooling_System-3"
          data-name="Cooling System"
          transform="translate(888 201)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.cooling_system' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_274"
            data-name="Path 274"
            d="M6157,979.656l123.46,1H6310.8"
            transform="translate(-5439.799 -782.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_288"
            data-name="Path 288"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(714 195)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 188)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(868 199)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['warning_lights'] || ''"
        [attr.data-name]="'mechanics.warning_lights' | translate"
      >
        <path
          class="parts"
          id="Warning_Lights-2"
          data-name="Warning Lights"
          d="M339.851,251.317l-12.686,25.831a1.594,1.594,0,0,0,1.429,2.3h27.447a1.593,1.593,0,0,0,1.384-2.383l-14.761-25.833A1.593,1.593,0,0,0,339.851,251.317Z"
          transform="translate(433.46 -85.305)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="111"
          height="19"
          rx="9.5"
          transform="translate(866 155)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Warning_Lights-3"
          data-name="Warning Lights"
          transform="translate(888 168)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.warning_lights' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_273"
            data-name="Path 273"
            d="M6157,998.035l72.427-18.379h17.8"
            transform="translate(-5381.225 -814.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_287"
            data-name="Path 287"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(773 181)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 156)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(868 167)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['electrical_systems'] || ''"
        [attr.data-name]="'mechanics.electrical_system' | translate"
      >
        <rect
          class="parts"
          id="Electrical_System-2"
          data-name="Electrical System"
          width="46.646"
          height="30.34"
          transform="translate(706.661 123)"
          fill="none"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="117"
          height="19"
          rx="9.5"
          transform="translate(866 122)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Electrical_System-3"
          data-name="Electrical System"
          transform="translate(888 135)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.electrical_system' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_272"
            data-name="Path 272"
            d="M6157,988.156l95.208-8.5h23.4"
            transform="translate(-5409.604 -848.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_117"
            data-name="Path 117"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(744 137)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 122)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(868 133)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['back_door_boot_mechanics'] || ''"
        [attr.data-name]="'mechanics.back_door_boot_mechanics' | translate"
      >
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="167"
          height="19"
          rx="9.5"
          transform="translate(617 664)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Back_Door_Boot_Mechanics-2"
          data-name="Back Door / Boot Mechanics"
          transform="translate(639 677)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.back_door_boot_mechanics' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(617 665)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(620 676)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="Back_Door_Boot_Mechanics-3"
          data-name="Back Door / Boot Mechanics"
          d="M8350,2463l-17.764,34h33.9Z"
          transform="translate(-7653 -1855)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-width="1"
        />
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_519"
            data-name="Path 519"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(694 628)"
            fill="#696969"
          />
          <path
            id="Path_520"
            data-name="Path 520"
            d="M8350,2510v-32.594"
            transform="translate(-7653 -1846)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_door_mechanics'] || ''"
        [attr.data-name]="'mechanics.rr_door_mechanics' | translate"
      >
        <path
          class="parts"
          id="RR_Door_Mechanics-2"
          data-name="RR Door Mechanics"
          d="M335.37,639.909l-33.719-1.789s-24.211-41.692-22.972-49.535l60.543,5.091Z"
          transform="translate(420.544 5)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="124"
          height="19"
          rx="9.5"
          transform="translate(866 653)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Door_Mechanics-3"
          data-name="RR Door Mechanics"
          transform="translate(888 666)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.rr_door_mechanics' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-29" data-name="Arrow">
          <path
            id="Path_286"
            data-name="Path 286"
            d="M6157,979.656l113.266,44H6298.1"
            transform="translate(-5432.001 -359.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_300"
            data-name="Path 300"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(722 617)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(866 654)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(868 665)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_axle'] || ''"
        [attr.data-name]="'mechanics.rr_axle' | translate"
      >
        <path
          class="parts"
          id="RR_Axle-2"
          data-name="RR Axle"
          d="M376.478,442.71l-6.605,11.353h-5.229l-2.614-4.954H340.015l-2.959-4.335s4.308-.987,5.573-4.128c2.889-12.8-12.178-5.366-12.178-5.366l-4.99-.62-3.06,3.716-24.355-10.733H279.612l-24.354,10.733-3.06-3.716-4.99.62s-15.068-7.43-12.178,5.366c1.264,3.141,5.572,4.128,5.572,4.128l-2.959,4.335H215.63l-2.615,4.954h-5.228l-6.605-11.353h-3.3V458.4l11.351,3.1,1.444-2.684,2.339-.413,3.853,3.1h15.48l3.1,2.684h3.508l2.064-3.3h16.306l6.4,9.289h6.192l2.064-5.78h33.709l2.064,5.78h6.191l6.4-9.289h16.306l2.064,3.3h3.508l3.1-2.684h15.48l3.852-3.1,2.34.413,1.444,2.684,11.351-3.1V442.71Z"
          transform="translate(398.979 -37.979)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-32"
          data-name="Rectangle 38"
          width="86"
          height="18"
          rx="9"
          transform="translate(443 398)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Axle-3"
          data-name="RR Axle"
          transform="translate(469 410)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.rr_axle' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-30" data-name="Arrow">
          <path
            id="Path_263"
            data-name="Path 263"
            d="M6266.315,990.978l-87.752-11.322H6157"
            transform="translate(-5629.604 -573.261)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_309"
            data-name="Path 309"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(634 415)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-32"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 398)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-32"
          data-name="3.0"
          transform="translate(513 409)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['transmission'] || ''"
        [attr.data-name]="'mechanics.transmission' | translate"
      >
        <path
          class="parts"
          id="Transmission-2"
          data-name="Transmission"
          d="M259.257,344.943s.125-8.588,10.133-8.588,10.594,8.588,10.594,8.588l-5.067,13.851c3.09,4.455,8.507,15.016.561,17.6-3.13,1.019-7.3.967-10.149-1.074-4.328-3.1-3.088-8.328-1.313-12.574.158-.38,1.679-2.79,1.536-3.125Z"
          transform="translate(415.37 -62.358)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-33"
          data-name="Rectangle 38"
          width="96"
          height="18"
          rx="9"
          transform="translate(433 295)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Transmission-3"
          data-name="Transmission"
          transform="translate(443 307)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.transmission' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-31" data-name="Arrow">
          <path
            id="Path_260"
            data-name="Path 260"
            d="M6316.324,979.656l-127.9.333H6157"
            transform="translate(-5627.604 -676.594)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_312"
            data-name="Path 312"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(685 300)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-33"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 295)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-33"
          data-name="3.0"
          transform="translate(513 306)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_axle'] || ''"
        [attr.data-name]="'mechanics.frt_axle' | translate"
      >
        <g class="parts" id="FRT_Axle-2" data-name="FRT Axle">
          <path
            id="Path_225"
            data-name="Path 225"
            d="M276.64,356.964V346.679l11.145,1.513,14.242-8.461a3.954,3.954,0,0,1,5.263,0c2.889,2.269-8.05,10.525-8.05,10.525h23.323v4.679H295.869s-7.017,9.149-11.008,2.029Z"
            transform="translate(420.011 -61.726)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_229"
            data-name="Path 229"
            d="M268.551,356.964V346.679l-11.145,1.513-14.242-8.461a3.954,3.954,0,0,0-5.263,0c-2.889,2.269,8.05,10.525,8.05,10.525H222.628v4.679h26.694s7.017,9.149,11.008,2.029Z"
            transform="translate(405.588 -61.726)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </g>
        <rect
          id="Rectangle_38-34"
          data-name="Rectangle 38"
          width="77"
          height="18"
          rx="9"
          transform="translate(452 231)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Axle-3"
          data-name="FRT Axle"
          transform="translate(465 243)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.frt_axle' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-32" data-name="Arrow">
          <path
            id="Path_258"
            data-name="Path 258"
            d="M6275.244,1031.362l-94.918-51.706H6157"
            transform="translate(-5630.604 -741.261)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_313"
            data-name="Path 313"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(642 287)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-34"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 231)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-34"
          data-name="3.0"
          transform="translate(513 242)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_shocks'] || ''"
        [attr.data-name]="'mechanics.frt_shocks' | translate"
      >
        <g
          class="parts"
          id="FRT_Shocks-2"
          data-name="FRT Shocks"
          transform="translate(602.406 236.437)"
        >
          <path
            id="Path_226"
            data-name="Path 226"
            d="M312.253,356.327V337.546s-12.383-3.3-4.333-10.733a5.042,5.042,0,0,0-2.72-3.818c-2.543-1.342,0-4.128,0-4.128s-6.087-13.313,5.884-12.074S319.614,320,319.614,320s2.752,2.339,1.514,5.229,7.293,4.265-3.853,12.521V345.6s4.266,1.238.345,5.159c0,0,4.54,2.477,1.444,5.572S312.253,356.327,312.253,356.327Z"
            transform="translate(-175.182 -306.712)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_230"
            data-name="Path 230"
            d="M227.355,356.327V337.546s12.384-3.3,4.335-10.733a5.043,5.043,0,0,1,2.719-3.818c2.544-1.342,0-4.128,0-4.128s6.087-13.313-5.884-12.074S219.994,320,219.994,320s-2.751,2.339-1.513,5.229-7.293,4.265,3.853,12.521V345.6s-4.266,1.238-.345,5.159c0,0-4.541,2.477-1.444,5.572S227.355,356.327,227.355,356.327Z"
            transform="translate(-198.45 -306.712)"
            fill="#ffe6b7"
            stroke="#030504"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </g>
        <path
          id="Path_231"
          data-name="Path 231"
          d="M223.9,352.88l-1.775.888-4.279,2.14v-9.494L223.9,348.2Z"
          transform="translate(404.312 -59.672)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-35"
          data-name="Rectangle 38"
          width="96"
          height="18"
          rx="9"
          transform="translate(433 199)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Shocks-3"
          data-name="FRT Shocks"
          transform="translate(451 211)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'mechanics.frt_shocks' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-33" data-name="Arrow">
          <path
            id="Path_257"
            data-name="Path 257"
            d="M6258.672,1027.857l-81.615-48.2H6157"
            transform="translate(-5627.604 -770.261)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_315"
            data-name="Path 315"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(628 255)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-35"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 199)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-35"
          data-name="3.0"
          transform="translate(513 210)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['power_steering'] || ''"
        [attr.data-name]="'mechanics.power_steering' | translate"
      >
        <rect
          id="Rectangle_38-36"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(422 103)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-36"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(511 103)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-36"
          data-name="3.0"
          transform="translate(513 114)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Power_Steering-2"
          data-name="Power Steering"
          transform="translate(436 115)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'mechanics.power_steering' | translate }}
          </tspan>
        </text>
        <path
          class="parts"
          id="Power_Steering-3"
          data-name="Power Steering"
          d="M250.788,245.756a22.259,22.259,0,1,0,22.258,22.258A22.325,22.325,0,0,0,250.788,245.756Z"
          transform="translate(407.164 -86.552)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <circle
          id="circle_34"
          data-name="circle 34"
          cx="17.2"
          cy="17.2"
          r="17.2"
          transform="translate(640.751 164.262)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_222"
          data-name="Path 222"
          d="M265.7,261.994c-8.094,0-9.51-5.059-16.188-5.059s-7.588,5.059-16.189,5.059m20.236,19.224v-7.083a5.14,5.14,0,0,1,5.059-5.058H265.7m-32.377,0H240.4a4.948,4.948,0,0,1,5.059,5.058v7.083"
          transform="translate(408.443 -83.567)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <circle
          id="circle_35"
          data-name="circle 35"
          cx="4.047"
          cy="4.047"
          r="4.047"
          transform="translate(653.903 177.415)"
          fill="#ffe6b7"
          stroke="#030504"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <g class="arrow" id="Arrow-34" data-name="Arrow">
          <path
            id="Path_253"
            data-name="Path 253"
            d="M6289.6,1059.656l-106.447-80H6157"
            transform="translate(-5628.604 -867.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_317"
            data-name="Path 317"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(656 188)"
            fill="#696969"
          />
        </g>
      </g>
    </g>
  </svg>

  <loader [position]="{ absolute: true }" [active]="loaded"></loader>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : {{ 'exterior.qc_passed' | translate }}
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : {{ 'exterior.qc_failed' | translate }}
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <!-- Start -->
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>

          <!-- end -->
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <!-- {{imageOld['beforeImg1']}} -->
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Audio/Video -->
      <div class="container mt-4" *ngIf="modalTitle === 'Engine'">
        <div class="row">
          <div class="card mb-3" style="width: 100%">
            <span class="text-center py-2 font-weight-bold">Before</span>
            <div style="display: flex; flex-direction: row">
              <div class="col-md-6 mb-3">
                <app-media-section
                  [vehicleId]="vehicleId"
                  [label]="'Audio'"
                  [type]="'audio'"
                  [phase]="'Before'"
                  [parentPartId]="partId"
                  [mediaSrc]="hasBeforeAudio"
                  [openHandler]="openAudioVideoModal.bind(this)"
                  (onDeleteSuccess)="handleDeleteSuccess($event, 'Before', 'Audio')"
                ></app-media-section>
              </div>

              <div class="col-md-6 mb-3">
                <app-media-section
                  [vehicleId]="vehicleId"
                  [label]="'Video'"
                  [type]="'video'"
                  [phase]="'Before'"
                  [parentPartId]="partId"
                  [mediaSrc]="hasBeforeVideo"
                  [openHandler]="openAudioVideoModal.bind(this)"
                  (onDeleteSuccess)="handleDeleteSuccess($event, 'Before', 'Video')"
                ></app-media-section>
              </div>
            </div>
          </div>

          <div class="card" style="width: 100%">
            <span class="text-center py-2 font-weight-bold">After</span>

            <div style="display: flex; flex-direction: row">
              <div class="col-md-6 mb-2">
                <app-media-section
                  [vehicleId]="vehicleId"
                  [label]="'Audio'"
                  [type]="'audio'"
                  [phase]="'After'"
                  [parentPartId]="partId"
                  [mediaSrc]="hasAfterAudio"
                  [openHandler]="openAudioVideoModal.bind(this)"
                  (onDeleteSuccess)="handleDeleteSuccess($event, 'After', 'Audio')"
                ></app-media-section>
              </div>

              <div class="col-md-6 mb-2">
                <app-media-section
                  [vehicleId]="vehicleId"
                  [label]="'Video'"
                  [type]="'video'"
                  [phase]="'After'"
                  [parentPartId]="partId"
                  [mediaSrc]="hasAfterVideo"
                  [openHandler]="openAudioVideoModal.bind(this)"
                  (onDeleteSuccess)="handleDeleteSuccess($event, 'After', 'Video')"
                ></app-media-section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="
            !vehicleStatus &&
            ((editableRole.includes(role) && role !== 'estimator') ||
              ['qc', 'evaluator'].includes(role))
          "
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- Audio/Video Modal -->
<div
  bsModal
  #audioAndVideo="bs-modal"
  class="modal fade"
  tabindex="-1"
  [config]="{ backdrop: 'static', keyboard: false }"
  role="dialog"
  aria-labelledby="dialog-sizes-name1"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Please record</h4>
        <button
          type="button"
          class="btn-close close pull-right"
          (click)="handleAudioVideoModalClose()"
          aria-label="Close"
        >
          <span aria-hidden="true" class="visually-hidden">
            <ion-icon name="close-outline"></ion-icon>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="modalType === 'audio'">
          <app-audio-recorder
            [vehicleId]="vehicleId"
            [phase]="phase"
            [parentPartId]="partId"
            (onUploadSuccess)="handleUploadSuccess($event, 'audio')"
          ></app-audio-recorder>
        </ng-container>

        <ng-container *ngIf="modalType === 'video'">
          <app-video-recorder
            [vehicleId]="vehicleId"
            [phase]="phase"
            [parentPartId]="partId"
            (onUploadSuccess)="handleUploadSuccess($event, 'video')"
          ></app-video-recorder>
        </ng-container>
      </div>
    </div>
  </div>
</div>
